/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".properties-list[_ngcontent-%COMP%]{max-height:45vh;overflow-y:auto}.mapping-open-label[_ngcontent-%COMP%]{font-size:12px;font-style:italic;color:#f44336;white-space:nowrap}.close-mapping-checkbox[_ngcontent-%COMP%]     .mat-checkbox-layout .mat-checkbox-label{white-space:nowrap}.property-checkbox[_ngcontent-%COMP%]{min-width:0}.property-checkbox[_ngcontent-%COMP%]     .mat-checkbox-label{white-space:normal}"];
export { styles as styles };
